import Vue from "vue";
import Login from "../pages/Login.vue";
import Vuex from "vuex";
import Store from "../vuex/store";
import 'toastr2/dist/toastr.min.css';

Vue.use(Vuex);
new Vue({
    render: h => h(Login),
    store: new Vuex.Store(Store)
}).$mount("#root");